import { fetcher } from '../util/axios';
import { MatchingHistory } from '../types/matching';

export const getMyInfo = async ():Promise<Auth> => {
  const request = await fetcher('member/me');
  return request.data as Auth;
};
